import { cache, FetchResponse } from '@hotwired/turbo';

/**
 * Handler for missing frame events with Symfony full page errors and
 * redirections.
 */
export default class MissingFrameHandler {
    constructor() {
        document.addEventListener('turbo:frame-missing', this._handleMissingFrame);
    }

    _handleMissingFrame = async (event) => {
        const response = event.detail.response;

        if (!response
            || (response.ok && !response.redirected)
        ) {
            // let Turbo display the error for better developer experience
            return;
        }

        event.preventDefault();

        const wrapped = new FetchResponse(response);
        const responseHTML = await wrapped.responseHTML;
        const { location, redirected, statusCode } = wrapped;

        cache.clear();
        event.detail.visit(location, { response: { redirected, statusCode, responseHTML } })
    };
}
